// src/components/setupstyles/DashboardLayout.js

import React from 'react';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import embossedImage from '../../assets/mindguard_4.jpg';

const DashboardLayout = () => {
  const navigate = useNavigate();

  console.log("Rendering DashboardLayout"); // Log to see if this component is being rendered

  const handleSelect = (selection) => {
    console.log("Sidebar selection:", selection); // Log the selection from the sidebar
    if (selection === 'homepage') {
      navigate('/');
    } else if (selection === 'serverConfig') {
      navigate('/setup');
    } else if (selection === 'currentConfigs') {
      navigate('/current-configs');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundImage: `url(${embossedImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center 93%',
        backgroundRepeat: 'no-repeat',
        position: 'relative', // To allow stacking
      }}
    >
      <Sidebar />
      <Box
        sx={{
          flexGrow: 1, // Occupy remaining space
          padding: 3,
          overflowY: 'auto', // Enable scrolling if content overflows
          backgroundColor: 'rgba(255, 255, 255, 0)', // Transparent to show background
        }}
      >
        <Outlet /> {/* Renders the nested route component */}
      </Box>
    </Box>
  );
};

export default DashboardLayout;

